import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    ZephyrLogo: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'ZephyrLogo' };

import { computed } from 'vue';
import type { StyleValue } from 'vue/types/jsx';
import { uniqueId } from 'lodash';

import { isString, isNotNullish } from '@tools/type-guards';

/**
 * ...
 */
export interface DropShadow {
  size: number;
  xOffset?: number;
  yOffset?: number;
  color?: string;
}

/**
 * `ZephyrLogo` component properties.
 */
export interface Props {
  /** ... */
  width?: string | number | null;
  /** ... */
  colors?: string | string[] | null;
  /** ... */
  shadow?: DropShadow | DropShadow[] | null;
  /** ... */
  animate?: boolean;
}

/** Default gradient of the Zephyr logo. */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    width: { default: null },
    colors: { default: null },
    shadow: { default: null },
    animate: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { width: string | number | null, colors: string | string[] | null, shadow: DropShadow | DropShadow[] | null, animate: boolean };

const DEFAULT_LOGO_GRADIENT = ['#FBAF40', '#F15A29'];



/** ... */
const id = uniqueId();

/** ... */
const gradientId = computed(() => {
  return `logo-${id}-gradient-overlay`;
});

/** ... */
const style = computed(() => {
  const style: StyleValue = {};

  if (isNotNullish(props.width)) {
    style.width = isString(props.width) ? props.width : `${props.width}px`;
  }

  return style;
});

/** ... */
const svgStyle = computed(() => {
  const style: StyleValue = {};

  // ...
  if (props.shadow) {
    style.filter = createDropShadowFilterStyle(props.shadow);
  }

  return style;
});

/** ... */
const gradient = computed(() => {
  const colors = !props.colors
    ? DEFAULT_LOGO_GRADIENT
    : Array.isArray(props.colors)
    ? props.colors
    : [props.colors];

  return colors.map((color, index) => ({
    key: index,
    color,
    offset: Math.round(100 * ((index === 0 ? 0 : index + 1) / colors.length)),
  }));
});

//#region Helper Functions

/**
 * ...
 *
 * @param options ...
 * @return ...
 */
function createDropShadowFilterStyle(options: DropShadow | DropShadow[]) {
  const shadows = Array.isArray(options) ? options : [options];

  return shadows
    .map(({ xOffset, yOffset, size, color }) => {
      const values: (string | number)[] = [];

      values.push((xOffset ?? 0).toString() + 'px');
      values.push((yOffset ?? 0).toString() + 'px');
      values.push(size.toString() + 'px');
      values.push(color ?? 'black');

      return `drop-shadow(${values.join(' ')})`;
    })
    .join(' ');
}

//#endregion Helper Functions

return { __sfc: true,DEFAULT_LOGO_GRADIENT, props, id, gradientId, style, svgStyle, gradient, createDropShadowFilterStyle }
}

})